import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const NotificationManagerContext = createContext(null);

export function NotificationManagerProvider({ notificationManager, children }) {
  return (
    <NotificationManagerContext.Provider value={notificationManager}>
      {children}
    </NotificationManagerContext.Provider>
  );
}

export function withNotificationManager(component) {
  const Component = component;
  return props => (
    <NotificationManagerContext.Consumer>
      {notificationManager => <Component {...props} notificationManager={notificationManager} />}
    </NotificationManagerContext.Consumer>
  );
}

NotificationManagerProvider.propTypes = {
  notificationManager: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/NotificationManagerContext/index.jsx